import React from 'react';
import { AnyAction } from 'redux';
import { all, takeEvery, fork, put, select, delay, call } from 'redux-saga/effects';
import { notification } from 'antd';

import { authAsActionTypes, authAsSelectors } from '.';
import { authSaga, authActions, authSelectors } from '../auth';
import { closeNavPanel } from '../appConfig/actions';

import AuthAs from '../../services/authAs';

import Translation from '../../components/UI/Translation';

import StorageManager from '../../helpers/storageManager';

export function* openTeacherModalWatcher(): Generator {
  yield takeEvery(authAsActionTypes.OPEN_SIGNIN_AS_TEACHER_MODAL, openTeacherModal);
}
/**
 * uruchomienie efektów ubocznych utwarcia modala
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* openTeacherModal(): Generator {
  yield put(closeNavPanel());
}
export function* getTeachersWatcher(): Generator {
  yield takeEvery(authAsActionTypes.GET_TEACHERS_START, getTeachers);
}
/**
 * Obsługa zapytania o listę nauczycieli
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* getTeachers(action: AnyAction): Generator {
  try {
    const response: any = yield call(AuthAs.getTeachers, action.payload.value);
    yield put({
      type: authAsActionTypes.GET_TEACHERS_SUCCESS,
      payload: { teachers: response.pracownikPage.data },
    });
  } catch (error) {
    yield put({
      type: authAsActionTypes.GET_TEACHERS_FAIL,
    });
    yield put(authActions.executeErrorCode(error.errorCode, action, error));
  }
}
export function* signinAsTeacherWatcher(): Generator {
  yield takeEvery(authAsActionTypes.SIGNIN_AS_TEACHER_START, signinAsTeacher);
}
/**
 * Obsługa zapytania o zalogowania jako nauczyciel
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* signinAsTeacher(action: AnyAction): Generator {
  try {
    const { selectedValue }: authAsActionTypes.TeacherModal | any = yield select(authAsSelectors.getSelectedteacherId);
    if (selectedValue) {
      const response: any = yield call(AuthAs.signinAsTeacher, selectedValue);
      //w razie sukcesu usuń dane z cookies oraz localStore zapisz token i refresh token do localStorage
      StorageManager.clearTokens();
      StorageManager.set('id_token', response.token, true);
      StorageManager.set('refresh_token', response.refreshToken, true);
      //zresetuj wszystkie store do danych initowych
      yield put(authActions.resetReducers());
      yield call(window.stop);
      //wywołaj odpytanie whoAmI
      yield call(authSaga.whoIAm, authActions.whoAmI());
      yield put({
        type: authAsActionTypes.SIGNIN_AS_TEACHER_SUCCESS,
      });
      const { firstName, lastName } = (yield select(authSelectors.getUser)) as AppConfig.User;
      pushNotification(
        'success',
        'SUPERTEACHER_MODAL_LOG_AS_SUCCESS_TITLE',
        'SUPERTEACHER_MODAL_LOG_AS_SUCCESS_BODY',
        `${firstName} ${lastName}`,
        'cySignInAsTeacherNotification',
      );
    }
  } catch (error) {
    yield put({
      type: authAsActionTypes.SIGNIN_AS_TEACHER_FAIL,
    });
    yield put(authActions.executeErrorCode(error.errorCode, action, error));
  }
}
export function* logoutToSuperteacherWatcher(): Generator {
  yield takeEvery(authAsActionTypes.LOGOUT_AS_START, logoutToSuperteacher);
}
/**
 * Obsługa zapytania o wylogowanie z konta nauczyciela do konta supernauczyciela
 *
 * @export
 * @param {AnyAction} action
 * @return {*}  {Generator}
 */
export function* logoutToSuperteacher(action: AnyAction): Generator {
  try {
    const response: any = yield call(AuthAs.logoutToSuperteacher);
    //w razie sukcesu usuń dane z cookies oraz localStore zapisz token i refresh token do localStorage
    StorageManager.clearTokens();
    StorageManager.set('id_token', response.token.token, true);
    StorageManager.set('refresh_token', response.token.refreshToken, true);
    //zresetuj wszystkie store do danych initowych
    yield put(authActions.resetReducers());
    yield call(window.stop);
    //wywołaj odpytanie whoAmI
    yield call(authSaga.whoIAm, authActions.whoAmI());
    yield put({
      type: authAsActionTypes.LOGOUT_AS_SUCCESS,
    });
    const { firstName, lastName } = (yield select(authSelectors.getUser)) as AppConfig.User;
    pushNotification(
      'success',
      'SUPERTEACHER_MODAL_LOGOUT_SUCCESS_TITLE',
      'SUPERTEACHER_MODAL_LOGOUT_SUCCESS_BODY',
      `${firstName} ${lastName}`,
    );
  } catch (error) {
    yield put({
      type: authAsActionTypes.LOGOUT_AS_FAIL,
    });
    yield put(closeNavPanel());
    pushNotification('error', 'SUPERTEACHER_MODAL_LOGOUT_ERROR_TITLE', 'SUPERTEACHER_MODAL_LOGOUT_ERROR_BODY', '');
    yield delay(3000);
    yield put(authActions.logout());
    yield put(authActions.executeErrorCode(error.errorCode, action, error));
  }
}

type NotificationType = 'success' | 'info' | 'error' | 'warning';

const pushNotification = (
  type: NotificationType,
  idTitle: string,
  idDescription: string,
  description: string,
  className?: string,
): void => {
  const args = {
    message: <Translation id={idTitle} />,
    description: (
      <>
        <Translation id={idDescription} />
        <span style={{ fontWeight: 'bold' }}>{`${description}`}</span>
      </>
    ),
    className: className,
  };
  notification[type](args);
};

export default function* rootSaga(): Generator {
  yield all([
    fork(openTeacherModalWatcher),
    fork(getTeachersWatcher),
    fork(signinAsTeacherWatcher),
    fork(logoutToSuperteacherWatcher),
  ]);
}
